module.exports = __webpack_public_path__ + "img/image_charactor.8d973a78.png";